export const PREPAYMENT_STATUS = {
  DRAFT: 'draft',
  OPEN: 'open',
  PARTLY_PAID: 'partly_paid',
  OVERPAID: 'overpaid',
  FULLY_PAID: 'fully_paid',
  PAID: 'paid',
  CREDITED: 'credited',
  LINK_SENT: 'link_sent',
  LINK_EXPIRED: 'link_expired',
  PAYMENT_NON_TRACKABLE: 'payment_non_trackable',
  PAYMENT_FAILED: 'payment_failed',
  DELETED: 'deleted',
} as const

export const PAID_PREPAYMENT_STATUSES: readonly string[] = [
  PREPAYMENT_STATUS.OPEN,
  PREPAYMENT_STATUS.PAID,
  PREPAYMENT_STATUS.FULLY_PAID,
  PREPAYMENT_STATUS.CREDITED,
]

export function isPrepaymentLinkSent(status?: string | null): boolean {
  return status === PREPAYMENT_STATUS.LINK_SENT
}

export function isPrepaymentAlreadyActive(
  prepaymentType?: string | null,
  prepaymentStatus?: string | null,
): boolean {
  if (prepaymentType !== 'online_payment' || !prepaymentStatus) return false
  return (
    prepaymentStatus === PREPAYMENT_STATUS.LINK_SENT ||
    prepaymentStatus === PREPAYMENT_STATUS.OPEN ||
    prepaymentStatus === PREPAYMENT_STATUS.PAID ||
    PAID_PREPAYMENT_STATUSES.includes(prepaymentStatus)
  )
}

type GetPrepaymentLabelOptions = {
  fallback?: string | null
  prepayment?: boolean | null
}

const LABEL_IDS = {
  prepayment: {
    waiting: 'towingRecord.prepayment_status_waiting',
    completed: 'towingRecord.prepayment_status_completed',
    failed: 'towingRecord.prepayment_status_failed',
    credited: 'towingRecord.prepayment_status_credited',
  },
  payment: {
    waiting: 'towingRecord.payment_status_waiting',
    completed: 'towingRecord.payment_status_completed',
    failed: 'towingRecord.payment_status_failed',
    credited: 'towingRecord.payment_status_credited',
  },
} as const

export function getPrepaymentLabel(
  translateMessage: (messageId: string) => string,
  statusDescription: string | null | undefined,
  options?: GetPrepaymentLabelOptions,
): string | null {
  const labelIds = options?.prepayment === false ? LABEL_IDS.payment : LABEL_IDS.prepayment

  switch (statusDescription) {
    case PREPAYMENT_STATUS.DRAFT:
    case PREPAYMENT_STATUS.LINK_SENT:
      return translateMessage(labelIds.waiting)
    case PREPAYMENT_STATUS.OPEN:
    case PREPAYMENT_STATUS.PAID:
    case PREPAYMENT_STATUS.FULLY_PAID:
      return translateMessage(labelIds.completed)
    case PREPAYMENT_STATUS.LINK_EXPIRED:
    case PREPAYMENT_STATUS.PAYMENT_NON_TRACKABLE:
    case PREPAYMENT_STATUS.PAYMENT_FAILED:
      return translateMessage(labelIds.failed)
    case PREPAYMENT_STATUS.CREDITED:
      return translateMessage(labelIds.credited)
    case PREPAYMENT_STATUS.DELETED:
      return null
    default:
      return options?.fallback ?? null
  }
}
